import React from "react";

export const SolarPanel: React.FC = () => {
    return (
        <img src={'/icon_solar_panel.png'} alt={"Solar Panel"} height={92} width={92} />
    );
};